<template>
  <div>
    <template v-for="(option, key) in options">
      <BaseButton
        :class="{ active: active(key) }"
        :key="key"
        class="mx-1 button-option"
        @click="toggle(key)">{{ option }}</BaseButton>
    </template>
  </div>
</template>

<script>
import BaseButton from './BaseButton.vue'

export default {
  name: 'ButtonOptions',

  components: {
    BaseButton
  },

  props: {
    name: String,
    options: Object,
    value: {}
  },

  methods: {
    active (key) {
      return key === String(this.value)
    },

    toggle (key) {
      this.$emit('input', key)
    }
  }
}
</script>
